import { createApi } from '@reduxjs/toolkit/query/react';
import { fakeBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import BackendApiClient from '../../services/api/BackendApiClient';

export interface GetDeliveryCompatibleCompaniesReqDto {
  franchiseId: number;
  latitude: number;
  longitude: number;
  street_name: string;
  street_number: string;
  city: string;
  zip_code: string;
  country?: null | string;
}

export const franchisesApiSlice = createApi({
  baseQuery: fakeBaseQuery(),
  reducerPath: 'franchisesApiSlice',
  endpoints: (build) => ({
    getDeliveryCompatibleCompanies: build.query<number[], GetDeliveryCompatibleCompaniesReqDto>({
      queryFn: ({ franchiseId, ...data }) =>
        BackendApiClient.request({
          method: 'POST',
          url: `/franchises/${franchiseId}/delivery-compatible-companies`,
          data,
        }).then((res) => {
          if (res.success) {
            return { data: res.response.data, status: res.status };
          }

          return {
            error: {
              data: res.response,
              status: res.status,
            },
          };
        }),
      keepUnusedDataFor: 60,
    }),
  }),
});

export const { useGetDeliveryCompatibleCompaniesQuery, useLazyGetDeliveryCompatibleCompaniesQuery } =
  franchisesApiSlice;
